export const portalJa = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "ようこそ — どのようなご用件でしょうか？",
    subtitle: "ご来訪の目的をお知らせください。最適なご案内をいたします。",
    later: "後で行う",
    back: "戻る",
    choices: {
      applyTitle: "Thailand Elite に申し込む：Thailand Privilege ビザ",
      applyDesc: "会員資格・長期滞在ビザの申請を開始します。",
      memberTitle: "すでに Thailand Elite 会員です",
      memberDesc: "会員資格を関連付ける、または会員サービスを依頼します。",
      prospectTitle: "決める前に質問があります",
      prospectDesc: "情報を入手し、アドバイザーに相談します。",
      partnerTitle: "代理店またはパートナーの代表です",
      partnerDesc: "提携・紹介の選択肢をご確認ください。",
      otherTitle: "その他",
      otherDesc: "その他のご依頼 — どのようにお手伝いできるかお知らせください。",
      servicesTitle: "不動産・保険・その他のサービス",
      servicesDesc: "不動産、保険、他のビザ、タイでの生活準備のサポート。",
    },
    applicant: {
      heading: "簡単な質問にお答えください",
      subtitle: "申請内容を最適化するために役立ちます。後で変更できます。",
      purposeLabel: "Thailand Elite を選ぶ主な理由は何ですか？",
      timelineLabel: "いつ申請または移住をご予定ですか？",
      submit: "申請に進む",
    },
    purpose: {
      retirement: "リタイア / 長期滞在",
      business: "ビジネス / 仕事",
      family: "家族 / 扶養家族",
      investment: "投資",
      lifestyle: "ライフスタイル / 頻繁な旅行",
      other: "その他",
    },
    timeline: {
      asap: "できるだけ早く",
      m1_3: "1〜3か月以内",
      m3_6: "3〜6か月以内",
      m6_12: "6〜12か月以内",
      exploring: "まずは情報収集中",
    },
    member: {
      heading: "おかえりなさい — 会員情報を確認しましょう",
      subtitle: "会員番号をお知らせください。簡単な確認の後、このアカウントに関連付けます。",
      idLabel: "会員番号 / カード番号",
      idPlaceholder: "例：TPC123456",
      sinceLabel: "いつから会員ですか？",
      sincePlaceholder: "例：2022",
      viaLabel: "どのように申請されましたか？",
      viaPlaceholder: "代理店、直接など",
      helpLabel: "どのようにお手伝いできますか？",
      helpPlaceholder: "ご依頼内容をご記入ください（ビザ貼付、90日レポート、更新など）。",
      submit: "送信",
    },
    inquiry: {
      heading: "もう少し詳しくお聞かせください",
      subtitle: "ご依頼を適切な担当者にお繋ぎし、フォローアップいたします。",
      typeLabel: "ご依頼の内容は何ですか？",
      messageLabel: "メッセージ",
      messagePlaceholder: "どのようにお手伝いできるかお知らせください。",
      submit: "依頼を送信",
    },
    inquiryTypes: {
      general_inquiry: "一般的なご質問",
      member_service: "既存会員 — サービス依頼",
      partnership: "代理店 / 提携",
      visa_other: "その他のビザ・入国に関するご質問",
      other_services: "不動産・保険・その他のサービス",
      other: "その他",
    },
    services: {
      heading: "どのようなご用件でしょうか？",
      subtitle: "ご興味のあるものをすべてお選びください。最適なパートナーをご紹介します。",
      interestsLabel: "興味のある分野",
      messageLabel: "補足事項はありますか？",
      messagePlaceholder: "例：バンコクでコンドミニアムを探している、2人分の医療保険…",
      submit: "送信",
      needInterestTitle: "1つ以上選択してください",
      needInterestDesc: "ご興味のある内容をお知らせください。",
    },
    interests: {
      real_estate: "不動産",
      insurance: "医療・旅行保険",
      other_visa: "他のビザ",
      business_setup: "会社設立",
      relocation: "移住サポート（学校・銀行など）",
      extraLabel: "タイで他にお手伝いできることはありますか？",
    },
    deleteAccount: {
      link: "誤ってアカウントを作成しましたか？削除する",
      title: "アカウントを削除しますか？",
      desc: "アカウントと入力された情報は完全に削除されます。この操作は元に戻せません。",
      confirm: "アカウントを削除",
      cancel: "キャンセル",
      doneTitle: "アカウントを削除しました",
      doneDesc: "アカウントは削除されました。またのご利用をお待ちしております。",
      failedTitle: "アカウントを削除できませんでした",
      notEligible: "このアカウントには申請または会員資格があります。メッセージでご連絡いただければ、こちらで手続きいたします。",
    },
    done: {
      title: "ご依頼を送信しました",
      desc: "ありがとうございます — 担当チームが確認し、まもなくご連絡いたします。",
      cta: "ダッシュボードへ",
    },
    optionalTag: "（任意）",
    memberOutcome: {
      linkedTitle: "会員資格を関連付けました ✓",
      linkedDesc: "おかえりなさい — 会員エリアの準備が整いました。",
      pendingTitle: "あと少し — 会員資格をご確認ください",
      pendingDesc: "ご登録のメールアドレス（{{email}}）に確認メールをお送りしました。お客様のご確認と当チームの承認後、会員資格が関連付けられます。",
    },
    banner: {
      memberTitle: "ありがとうございます — 会員資格を確認しています",
      memberDesc: "担当チームがまもなく会員番号をこのアカウントに関連付けます。確認が取れ次第ご連絡します。",
      prospectTitle: "お問い合わせありがとうございます",
      prospectDesc: "アドバイザーがご希望の情報についてご連絡します。お申し込みの準備はできましたか？下記からいつでも開始できます。",
      partnerTitle: "提携にご関心をお寄せいただきありがとうございます",
      partnerDesc: "提携をご希望ですか？会社概要を送信して始めましょう。または提携担当チームよりご連絡いたします。",
      partnerCta: "パートナーになる",
      otherTitle: "ご依頼を受け付けました",
      otherDesc: "担当チームが確認し、まもなくご連絡いたします。",
    },
    toast: {
      saveFailedTitle: "保存できませんでした",
      saveFailedDesc: "もう一度お試しください。",
      applicantOkTitle: "それでは始めましょう",
      applicantOkDesc: "申請を開始できます。",
      needMessageTitle: "短いメッセージをご入力ください",
      needMessageDesc: "どのようにお手伝いできるかお知らせください。",
    },
  },
  common: {
    saveAndContinue: "保存して続ける",
    back: "戻る",
    submit: "申請を提出する",
    submitting: "提出中…",
    saving: "保存中…",
    uploading: "アップロード中…",
    required: "必須",
    optional: "任意",
    yes: "はい",
    no: "いいえ",
    select: "選択してください…",
    uploaded: "アップロード済み",
    missing: "未提出",
    loading: "読み込み中…",
    download: "ダウンロード",
    upload: "アップロード",
    remove: "削除",
    retry: "再試行",
    next: "次へ",
    close: "閉じる",
    addDocuments: "書類を追加",
    signOut: "サインアウト",
    memberPortal: "会員ポータル",
    language: "言語",
    // Toast messages
    fileTooLarge: "ファイルサイズが大きすぎます",
    maxSizeAllowed: "最大{{size}}まで。",
    uploadFailed: "アップロードに失敗しました",
    invalidEmail: "無効なメールアドレス",
  },

  dashboard: {
    nextMemberApp: "同伴会員申請",
    addNextMember: "同伴会員を追加",
    nextMemberPromo: "キャンペーン：同伴会員1人75万バーツ（2026年12月31日まで）",
    myApplications: "申請一覧",
    noApplications: "申請はありません",
    noApplicationsDesc: "最初の申請を作成して、タイランドエリートの旅を始めましょう。",
    createApplication: "申請を作成",
    newApplication: "新規申請",
    resumeApplication: "申請を再開",
    alreadyActiveTitle: "申請が進行中です",
    alreadyActiveDesc: "既に進行中の申請があります。新しい申請を作成する前に、完了またはキャンセルしてください。",
    package: "プログラム",
    created: "作成日",
    messages: "メッセージ",
    newThread: "新しいスレッド",
    newThreadSubject: "件名",
    newThreadBody: "メッセージ",
    generalInquiry: "一般的なお問い合わせ",
    noMessages: "メッセージはありません",
    status: {
      open: "オープン",
      waiting_reply: "返信待ち",
      closed: "クローズ",
      draft: "下書き",
      submitted: "提出済み",
      under_review: "審査中",
      background_check: "身元調査中",
      approved: "承認済み",
      payment_pending: "支払い待ち",
      payment_done: "有効化待ち",
      active: "有効",
      cancelled: "キャンセル済み",
      rejected: "却下",
    },
  },

  membership: {
    card: {
      sectionTitle: "会員カード",
      tierLabel: "会員資格",
      holderLabel: "カード名義人",
      numberLabel: "カード番号",
      validFrom: "有効開始日",
      validUntil: "有効期限",
      printOrSave: "印刷またはPDFとして保存",
    },
    documents: {
      lettersTitle: "公式レター",
      welcomeLetter: "ウェルカムレター",
      welcomeLetterDesc: "Thailand Elite 公式ウェルカムレター",
      welcomeLetterPending: "有効化の確認後、担当エージェントがアップロードします",
      certificationLetter: "認定レター",
      certificationLetterDesc: "Thailand Privilege の公式認定書類",
      certificationLetterPending: "Thailand Privilege による発行後にご利用いただけます",
      pending: "保留中",
    },
  },

  services: {
    tabLabel: "サービス",
    title: "会員サービス",
    intro: "サービス依頼を送信してください — ビザ貼付、90日通知、その他のお問い合わせなど。会員番号は自動的に添付されます。",
    chooseType: "サービスを選択",
    noTypes: "現在ご利用いただけるサービスはありません。サポートまでお問い合わせください。",
    estimated: "約{{days}}営業日",
    history: "過去のご依頼",
    back: "サービスに戻る",
    requirementsTitle: "ご提出いただくもの",
    memberIdLabel: "申請者",
    subject: "件名",
    messageLabel: "ご依頼内容をご記入ください",
    messagePlaceholder: "ご依頼を迅速に処理するために役立つ詳細をご記入ください。",
    attachments: "添付ファイル",
    addFile: "クリックしてアップロード（PDF / JPG / PNG、最大10MB）",
    send: "依頼を送信",
    submittedTitle: "依頼を送信しました",
    submittedDesc: "会員サービスチームが確認し、メッセージでご返信いたします。",
    submittedDescMcc: "担当チームが確認し、メッセージでご返信します。より早く処理するには、下の作成済みメールをMCCへお送りください。",
    mcc: {
      title: "MCCに直接連絡する",
      intro: "このサービスは Thailand Privilege メンバーコンタクトセンター（MCC）が予約します。用意した英文メールをご自身のメールから送信してください。当社にもコピーが届き、フォローいたします。",
      titleNext: "リクエストを早める：MCCにメール",
      recommended: "おすすめ・より早く処理",
      oneMinute: "1分で完了：メールは作成済みです。送信するだけです。",
      attachReminder: "書類は自動では添付されません（プライバシー保護のため）。メールに添付してください：{{files}}",
      linksIncluded: "書類は安全なリンクとしてメールに含まれています（{{date}} まで有効）。添付することもできます。",
      copyTip: "ヒント：「メールをコピー」してメールに貼り付けると、ファイル名がクリックできるリンクになります。",
      emailButton: "MCCにメール",
      gmailButton: "Gmailで開く",
      callButton: "MCCに電話",
      copyButton: "メールをコピー",
      copied: "メールをコピーしました。",
      preview: "メールを表示",
      hidePreview: "メールを隠す",
      confirmEmailTitle: "MCCにメールを送信しましたか？",
      confirmPhoneTitle: "MCCに連絡がつきましたか？",
      confirmHint: "MCCは通常数時間以内に回答します。お急ぎの場合は、メールを送信したうえで {{phone}} にもお電話ください。",
      yes: "はい",
      notYet: "まだです",
      statusEmail: "{{date}} にMCCへメールを送信しました。",
      statusPhone: "{{date}} にMCCへ電話しました。",
      copyReceived: "メールのコピーを受け取りました。",
      followupTitle: "MCCから回答はありましたか？",
      answered: "はい、解決しました",
      needHelp: "いいえ、サポートが必要です",
      thanks: "ありがとうございます。記録しました。",
      helpSent: "対応します。担当チームがMCCに確認します。",
      packageTitle: "ご契約のメンバーシップ：{{package}}",
      privilegePoints: "特典ポイント",
      privilegeBook: "2026年 特典ブック（PDF）",
      mccLine: "メンバーコンタクトセンター：{{email}} · {{phone}}",
      done: "完了",
    },
    details: {
      whereTitle: "ビザの貼付はどこで行いますか？",
      airport: "空港で、到着時に",
      airportHint: "到着日は本日から7日以降にしてください。航空券をご用意ください。",
      chaeng: "バンコクのチェーンワッタナー入国管理局で",
      chaengHint: "本日から5営業日以降の平日。TM30のコピーが必要です。",
      arrivalAirport: "到着空港",
      flightNumber: "便名",
      departureFrom: "出発地",
      departurePlaceholder: "例：東京 NRT",
      arrivalDate: "到着日",
      arrivalTime: "到着時刻（現地）",
      ticket: "航空券または旅程表",
      ticketHint: "PDFまたは写真。上記の便と一致するか確認します。",
      ticketChecking: "航空券を確認中…",
      ticketMatch: "確認済み：便名と日付が一致しています。",
      ticketMismatch: "航空券をご確認ください：",
      ticketUnreadable: "航空券を自動で読み取れませんでした。担当チームが確認します。",
      preferredDate: "希望日",
      period: "時間帯",
      morning: "午前（9:00–12:00）",
      afternoon: "午後（13:00–16:00）",
      alternativeDate: "第2希望（任意）",
      tentative: "日程は仮のもので、空き状況に応じて Member Services が確定します。",
      tm30: "TM30のコピー（住所証明）",
      tm30Hint: "家主またはホテルが発行したTM30の控え。",
      passportCopy: "パスポートのコピー（顔写真ページ）",
      passportHint: "ビザを貼付するパスポートです。新しいパスポートをお持ちの場合は、そちらをアップロードしてください。",
      passportFromApplication: "申請書類より",
      useApplicationPassport: "申請時のパスポートを使用",
      passportNewWarning: "申請時に使用したパスポートではありません。新しいパスポートの場合、ビザ貼付の前に入国管理局が身元審査をやり直す必要があり、時間がかかることがあります。追加で必要なものがあればご連絡します。",
      tm30Guide: "TM30とは？",
      upload: "アップロード",
      replace: "差し替え",
      bank: "銀行",
      bankPlaceholder: "銀行を選択",
      city: "都市",
      branch: "支店（任意）",
      branchPlaceholder: "例：Silom、Central World",
      bankHint: "最終判断は銀行が行い、追加書類を求められる場合があります。",
      ninetyTitle: "90日レポートについて",
      ninetySummary: "TM47は継続滞在90日ごとに住所を届け出る書類です。タイを出国するとカウントはリセットされます。期限の15日前から7日後まで提出でき、遅延には2,000バーツの罰金が科されます。",
      readGuide: "ガイドを読む",
      messageOptional: "その他お知らせいただくことはありますか？",
      noMessage: "詳細は以下をご覧ください。",
      licenseType: "免許の種類",
      car: "自動車",
      motorcycle: "バイク",
      both: "自動車とバイク",
      office: "陸運局の事務所",
      chatuchak: "バンコク・チャトゥチャック",
      otherOffice: "その他の事務所",
      otherOfficePlaceholder: "都市 / 事務所",
      homeLicense: "母国の有効な運転免許証",
      residenceCertificate: "居住証明書",
      residenceCertificateHint: "大使館発行のもの（または労働許可証）。",
      medicalCertificate: "診断書",
      medicalCertificateHint: "タイのクリニック発行、1か月以内のもの。予約前に取得することもできます。",
      drivingIntro: "当社の担当者が同行し、陸運局で1日で手続きが完了します。Privilegeビザ付きのパスポートをお持ちください。",
      drivingGuide: "運転免許ガイド",
      epaService: "サービス",
      epaArrival: "到着",
      epaDeparture: "出発",
      epaAirport: "空港",
      flightDate: "フライト日",
      flightTime: "フライト時刻（現地）",
      originCity: "出発都市",
      originCityPlaceholder: "例：東京",
      passengers: "人数",
      epaHint: "EPAの受付時間は6:00〜24:00です。フライトの5時間前までにご予約ください。",
      optional: "任意",
      docType: "書類の種類",
      docTypes: {
        passport: "パスポート",
        visa_page: "ビザのページ",
        photo: "写真",
        entry_stamp: "入国スタンプ",
        tm30: "TM30",
        flight_ticket: "航空券",
        home_license: "運転免許証（母国）",
        residence_certificate: "居住証明書",
        medical_certificate: "診断書",
        other: "その他の書類",
      },
      phone: "電話番号（MCC用）",
      phoneHint: "プロフィールから入力済みです。変更できます。",
      fromApplication: "申請書類から追加",
      fromApplicationHint: "申請時にアップロード済みの書類です。再アップロードは不要です。",
      appDocs: {
        passport_photo: "パスポート顔写真ページ",
        passport_signature: "パスポート署名ページ",
        visa: "ビザのページ",
        arrival_stamp: "入国スタンプ",
        profile_photo: "写真",
        marriage_certificate: "婚姻証明書",
        birth_certificate: "出生証明書",
      },
      errors: {
        licenseTypeRequired: "免許の種類を選択してください。",
        officeRequired: "事務所を選択してください。",
        homeLicenseRequired: "母国の運転免許証をアップロードしてください。",
        residenceCertificateRequired: "居住証明書をアップロードしてください。",
        epaServiceRequired: "到着または出発を選択してください。",
        flightDateRequired: "フライト日を入力してください。",
        flightDatePast: "フライト日が過ぎています。",
        flightTimeRequired: "フライト時刻を入力してください。",
        epaTooSoon: "EPAはフライトの5時間前までに予約が必要です。",
        originCityRequired: "出発都市を入力してください。",
        locationRequired: "貼付場所を選択してください。",
        airportRequired: "到着空港を選択してください。",
        flightNumberInvalid: "便名を入力してください（例：TG931）。",
        arrivalDateRequired: "到着日を入力してください。",
        arrivalTooSoon: "到着日は {{date}} 以降にしてください（本日から7日）。",
        arrivalTimeRequired: "到着時刻を入力してください。",
        preferredDateRequired: "希望日を選択してください。",
        weekend: "入国管理局は週末休業です。月曜〜金曜を選択してください。",
        appointmentTooSoon: "{{date}} 以降を選択してください（本日から5営業日）。",
        periodRequired: "午前または午後を選択してください。",
        alternativeInvalid: "第2希望は {{date}} 以降の平日にしてください。",
        tm30Required: "TM30のコピーをアップロードしてください。",
        passportRequired: "パスポートのコピーを添付してください。",
        bankRequired: "銀行を選択してください。",
        cityRequired: "都市を選択してください。",
      },
    },
  },

  wizard: {
    applicationSteps: "申請ステップ",
    step: "ステップ",
    of: "/",
    readOnlyBanner: "この申請は提出済みです。変更をご希望の場合はサポートまでお問い合わせください。",
    readOnlySupportLink: "変更を依頼する",
    backgroundCheckTitle: "申請審査中",
    backgroundCheckBody: "現在、当チームおよび関連するタイ当局がお客様の申請を審査しています。この段階では、申請のキャンセルや変更はできません。ご不明な点がございましたら、サポートチームまでお問い合わせください。",
    backgroundCheckExpected: "承認レターは概ね以下の頃にお届けできる見込みです：",
    backgroundCheckNote: "* これは通常4〜8週間の処理期間に基づく目安であり、保証されるものではありません。",
    backgroundCheckContact: "ご不明な点は当チームまでご連絡ください：",
    steps: {
      package: "プログラム",
      passport: "パスポート",
      personalInfo: "個人情報",
      address: "住所",
      visa: "ビザ・入国",
      documents: "書類",
      review: "確認",
    },
    stepDescriptions: {
      package: "タイランドエリート会員プログラムを選択してください",
      passport: "パスポートをアップロードして確認してください",
      personalInfo: "個人情報を入力してください",
      address: "居住地住所と連絡先情報",
      visa: "現在のビザと入国状況",
      documents: "必要書類をアップロードしてご署名ください",
      review: "申請内容を確認して提出してください",
    },
  },

  nextMember: {
    title: "同伴会員申請",
    subtitle: "既存のコア会員資格に基づき、同伴会員として申請されています。",
    badge: "同伴会員",
    addButton: "同伴会員を追加",
    relationship: "コア会員との続柄",
    selectRelationship: "続柄を選択…",
    relationships: {
      spouse: "配偶者",
      child: "子",
      parent: "親",
      adopted_child: "養子",
      civil_union: "シビルユニオンのパートナー",
    },
    coreApplication: "コア申請",
    additionalFee: "追加会員費用",
    promoLabel: "特別価格",
    regularFee: "通常価格",
    promoUntil: "2026年12月31日まで有効",
    perMember: "/人",
    existingNextMember: "同伴会員申請",
  },

  package: {
    title: "プログラムを選択",
    subtitle: "最適なタイランドエリート会員プログラムをお選びください。",
    selected: "選択済み",
    selectPackage: "このプログラムを選択",
    years: "年間",
    perYear: "毎年",
    includes: "含まれるもの",
    familyOption: "家族オプションあり",
  },

  passport: {
    title: "パスポート確認",
    subtitle: "OCR確認のためパスポートの顔写真ページをアップロードしてください。",
    uploadTitle: "パスポート写真をアップロード",
    uploadDesc: "パスポートの顔写真ページの写真またはスキャン（JPG、PNG、PDF — 最大10MB）",
    uploadHint: "タップしてアップロードまたは写真を撮る",
    extractTitle: "パスポート情報を読み取る",
    extractDesc: "クリックするとAIが自動で入力します — 数秒かかります",
    retakePhoto: "再撮影 / 再アップロード",
    passportNumber: "パスポート番号",
    surname: "姓",
    givenName: "名",
    nationality: "国籍",
    dateOfBirth: "生年月日",
    sex: "性別",
    dateOfIssue: "発行日",
    dateOfExpiry: "有効期限",
    placeOfBirth: "出生地",
    mrz: "機械読取領域（MRZ）",
    extractedData: "抽出データ",
    verifyAndContinue: "確認して続ける",
    lowConfidenceWarning: "一部のフィールドが明確に読み取れませんでした。続行前にご確認ください。",
    expiryWarning: "申請にはパスポートの有効期限が6ヶ月以上必要です。",
    expiryModalTitle: "パスポート有効期限の問題",
    expiryModalDesc: "申請日から1年以上のパスポート有効期間が必要です。申請前にパスポートを更新してください。",
    expiryModalCta: "了解しました",
    // Scan requirements
    scanRequirements: "スキャンの要件",
    scanReqColor: "フルカラースキャン — モノクロ不可",
    scanReqEdges: "四辺すべてが写っていること",
    scanReqResolution: "高解像度で、すべての文字が読み取れること",
    scanReqFocus: "ぼやけたり、ピントがずれていないこと",
    gallery: "ギャラリー",
    scanning: "スキャン中…",
    uploadDifferentFile: "別のファイルをアップロード",
    fileFormatHint: "JPG、PNG または PDF · 最大10MB",
    // Gender options
    male: "男性",
    female: "女性",
    // Placeholders
    cityOrTown: "市区町村",
    country: "国",
    asShownOnPassport: "パスポートの記載通り",
    ifApplicable: "該当する場合",
    // Toast messages
    passportUploaded: "パスポートをアップロードしました",
    passportUploadedDesc: "「AIでスキャン・自動入力」をクリックしてデータを抽出してください。",
    passportScanned: "パスポートをスキャンしました ✓",
    passportScannedDesc: "以下の抽出データをご確認ください。",
    qualityIssuesDetected: "品質の問題が検出されました",
    scanUnavailable: "スキャンを利用できません",
    scanUnavailableDesc: "以下の詳細を手動でご入力ください。",
    applicationAlreadyExists: "申請はすでに存在します",
    applicationAlreadyExistsDesc: "{{name}}の申請はすでに開始されています。再開するか、新しい申請者の場合はサポートまでお問い合わせください。",
    // OCR quality issues
    blurryImage: "画像がぼやけています",
    reflectionDetected: "反射 / 光の映り込みが検出されました",
    glareOnPassport: "パスポートに光の映り込みがあります",
    imageCropped: "画像が見切れています — パスポート全体が写るように再スキャンしてください",
    bioPageComplete: "顔写真ページが揃っています",
    mrzReadable: "MRZ が読み取り可能です",
    // Signature section
    signaturePage: "署名ページ",
    signatureOptional: "任意",
    signaturePageRequired: "顔写真ページに署名がない場合は、手書きの署名が記載されたパスポートのページをアップロードしてください。",
    signatureDetectedOnBio: "顔写真ページで署名が検出されました。パスポートに署名ページがある場合は、別途アップロードすることもできます。",
    signatureDetectedConfirm: "パスポートの顔写真ページで署名が検出されました ✓",
    signatureDetectedNote: "パスポートに専用の署名ページがある場合（フランス、イタリア、ドイツのパスポートに多い）は、以下にアップロードできます。",
    signatureNotCorrect: "正しくありません — このページに署名はありません",
    noSignatureOnBioPage: "顔写真ページに署名が見つかりませんでした",
    noSignatureOnBioPageNote: "一部のパスポートでは顔写真ページに署名が含まれていません — 署名が記載されたページをアップロードしてください。次の国のパスポートでは必須です：<strong>シンガポール、フィリピン、マレーシア、インドネシア、スウェーデン、UAE、サウジアラビア、カタール、クウェート、バーレーン、オマーン</strong>、およびほとんどの子供用パスポート。",
    signaturePageUploaded: "署名ページをアップロードしました",
    uploadSignaturePageOptional: "署名ページをアップロード（任意）",
    uploadSignaturePage: "署名ページをアップロード",
    replace: "差し替える",
    pdf: {
      label: "パスポートPDF",
      openPreview: "PDFプレビューを開く",
      detectedNote: "PDFが検出されました — パスポートの顔写真ページをPDFから直接読み取ります。",
    },
    ocrCooldown: "数秒待ってから再試行してください。",
  },

  personalInfo: {
    title: "個人情報",
    subtitle: "プロフィールと申請詳細を確認・入力してください。",
    profilePhoto: {
      title: "証明写真",
      desc: "最近撮影した顔写真（パスポートサイズ）。会員カードに使用されます。",
      uploadButton: "写真をアップロード",
      changeButton: "写真を変更",
      takePhoto: "写真を撮影",
      saved: "保存済み",
      photoSaved: "写真を保存しました ✓",
      photoUploadFailed: "写真のアップロードに失敗しました",
      removeBackgroundAi: "AIで背景を削除",
      removeBackgroundNote: "背景は白に置き換えられます — 次回のアップロード時に適用されます。",
    },
    identity: {
      sectionTitle: "身元情報",
      title: "敬称",
      givenName: "名",
      middleName: "ミドルネーム",
      surname: "姓",
      nameOnCard: "エリートカード表示名",
      nameOnCardHint: "会員カードに記載される名前",
      dateOfBirth: "生年月日",
      gender: "性別",
      occupation: "職業",
      businessIndustry: "業種",
    },
    applicationDetails: {
      sectionTitle: "申請詳細",
      sectionDesc: "パスポートスキャンから自動入力されています。パスポートデータが検出された場合は自動的に上書きされます。",
      fromPassport: "パスポートより",
      nationality: "国籍",
      placeOfBirth: "出生地",
      countryOfBirth: "出生国",
    },
    nationalityCheck: {
      question: "現在、他の国籍または市民権をお持ちですか？",
      otherNationality: "その他の国籍",
      passportsIntro: "保有するその他すべてのパスポートと国籍を申告してください。これらの情報は申請書2ページ目の「複数パスポート・国籍申告書」に記載され、ご署名いただきます。",
      passportHeading: "その他のパスポート {{n}}",
      passportNumber: "パスポート番号",
      issueDate: "発行日",
      expiryDate: "有効期限",
      nameOnPassport: "このパスポート上の氏名（異なる場合）",
      addPassport: "パスポートを追加",
      passportRequired: "その他のパスポートの国籍と番号を入力してください。",
      requiredDocsTitle: "複数国籍をお持ちの方の必要書類：",
      reqDoc1: "元の国籍のパスポート、および氏名が変更された場合は以前のパスポート。",
      reqDoc2: "元の国籍の放棄を証明する公的書類（該当する場合）。",
      reqDoc3: "収入および会員費用の資金源を証明する書類。",
      reqDoc4: "過去6か月間のタイ国内または海外での定住を証明する書類。",
      mismatchTitle: "出生国が国籍と異なります",
      mismatchIntro: "国籍は1つのみとご回答いただきましたが、出生国が市民権のある国と異なることを確認しました。",
      mismatchBody: "入国管理当局はビザ貼付に関して厳格な要件を設けており、追加書類を求められる場合があります。二重国籍をお持ちの場合は必ず申告してください。以前の国籍を放棄された場合は、関連する証明書類をご用意ください。",
      listTitle: "該当する場合は、以下をご提出ください：",
      doc1: "2冊目のパスポートの鮮明なコピー。",
      doc2: "現在の市民権の取得経緯を示す市民権証明書またはその他の書類のコピーと、簡単な説明。",
      doc3: "以前に別の国籍を保有し、その後放棄した場合は、国籍放棄証明書のコピー。",
      explanationLabel: "簡単な説明（任意）",
      explanationPlaceholder: "例：ブラジル生まれ、2010年に日本国籍取得、2012年にブラジル国籍を放棄。",
      uploadTitle: "証明書類",
      uploadDesc: "PDF、JPG、PNG — 各10MBまで。",
    },
    contact: {
      phone: "電話番号",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "メールアドレス",
      emailHint: "申請に使用されます。ログインメールと異なっても構いません。",
    },
    sharedProfile: "共有プロフィール",
    fillAllRequiredFields: "必須項目をすべて入力してください",
  },

  address: {
    title: "住所",
    subtitle: "現在の居住地住所。",
    currentAddress: "現住所",
    street: "番地・通り名",
    streetHint: "OpenStreetMap自動補完",
    startTyping: "住所を入力してください…",
    city: "市区町村",
    state: "都道府県 / 州",
    country: "国",
    postalCode: "郵便番号",
    thaiAddress: "タイの住所",
    haveThaiAddress: "タイの住所を持っています",
    accommodationType: "宿泊施設タイプ",
    province: "県",
    district: "郡",
    subDistrict: "タンボン",
    thaiTelephone: "電話番号（タイ）",
    thaiPhoneNote: "タイの電話番号（先頭の0を除く）",
    validationError: "番地、市区町村、国を入力してください",
  },

  visa: {
    title: "ビザ・入国状況",
    subtitle: "現在のタイビザと入国情報。",
    currentVisa: "現在のタイビザ",
    hasThaiVisa: "現在タイビザをお持ちですか？",
    visaType: "ビザの種類",
    visaExpiry: "ビザ有効期限",
    uploadVisaPage: "ビザページの写真",
    uploadVisaBtn: "ビザページをアップロード",
    arrivalStamp: "入国スタンプ",
    hasArrivalStamp: "現在入国スタンプをお持ちですか？",
    stampExpiry: "入国スタンプ有効期限",
    uploadStampPage: "入国スタンプページの写真",
    uploadStampBtn: "入国スタンプページをアップロード",
    passportStatus: "パスポートの状態",
    blankVisaPages: "パスポートに3ページ以上の空白ビザページがありますか？",
    blankYes: "はい — 3ページ以上",
    blankNo: "いいえ — 3ページ以下",
    overstayCount: "タイでのオーバーステイ回数（過去3年間）",
    overstayNever: "0 — なし",
    otherVisaOption: "その他（具体的に記入）",
    otherVisaLabel: "ビザの種類を記入してください",
    otherVisaPlaceholder: "略称（例：Non-O、SMART-T）",
    edVisa: {
      sectionTitle: "教育ビザ（ED）の履歴",
      sectionDesc: "タイランドエリートの資格審査に必要な申告事項です。",
      question: "過去5年間または現在のパスポートで教育ビザ（ED）をお持ちでしたか？",
      warningTitle: "追加の裏付け書類が必要です",
      warningDesc: "教育ビザの記録がある申請者は、以下の書類の提出が必要です。書類が不足すると不承認になる場合があります。",
      doc1: "学校設立許可証（สช.2 / OBEC / OPEC）",
      doc2: "学校登録証（ร.2）",
      doc3: "在学証明書",
      doc4: "成績証明書・通知表・出欠記録",
      doc5: "授業活動の写真",
      doc5Optional: "（任意 — 利用できない場合は後でアップロード可）",
      acknowledgementForm: "確認書",
      acknowledgementFormDesc: "ダウンロードして記入し、裏付け書類と一緒にアップロードしてください",
      uploadTitle: "裏付け書類をアップロード",
      uploadDesc: "PDF、JPG、またはPNG — 複数ファイルのアップロード可。申請に安全に保存されます。",
    },
  },

  visaReminder: {
    title: "重要 — 有効なビザを維持してください",
    body: "タイ国内に滞在されている場合は、常に有効なビザを保持してください。本申請の提出により、滞在期間の延長やタイ国内に留まる許可が与えられるものではありません。現在タイ国内に滞在されている場合は、申請手続きの間、ビザが有効であり続けるようご注意ください。",
  },

  documents: {
    title: "書類",
    subtitle: "申請フォームをダウンロード、署名してアップロードしてください。",
    applicationForm: {
      title: "申請フォーム",
      desc: "事前入力済みの申請フォームをダウンロードして電子署名後にアップロードしてください。",
      download: "事前入力PDFをダウンロード",
      signDigitally: "電子署名する",
      signatureCapture: "署名を取得",
      signatureCaptureDesc: "下に署名を描いてください",
      clear: "クリア",
      save: "署名を保存",
      appliedTo: "全ページに適用済み",
      uploadSigned: "署名済みフォームをアップロード",
    },
    pdpaForm: {
      title: "PDPA同意書",
      desc: "個人情報保護法の同意書。ダウンロード、署名してアップロードしてください。",
      download: "PDPAフォームをダウンロード",
      signDigitally: "電子署名する",
      uploadSigned: "署名済みフォームをアップロード",
    },
    uploadStatus: "アップロード状況",
    viewDocument: "アップロード済み書類を確認",
    downloadDocument: "署名済みPDFをダウンロード",
    signingComplete: "署名完了 — 保存するにはアップロードしてください",
    remaining: "残り",
    requiredDocuments: "必要書類",
    continueToReview: "確認に進む",
    blankForm: "空白フォーム",
    blankAddendum: "プロモーション補遺（空白）",
    downloadLabel: "ダウンロード",
    reprefill: "再入力",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "申請フォームを事前入力しました",
    applicationFormPrefilledDesc: "ダウンロードしました！全ページに署名し、アップロードまたは電子署名してください。",
    prefillFailed: "事前入力に失敗しました",
    applicationFormSigned: "申請フォームに署名して保存しました ✓",
    signingFailed: "署名に失敗しました",
    applicationFormUploaded: "申請フォームをアップロードしました ✓",
    pdpaFormSigned: "PDPA同意書に署名して保存しました ✓",
    pdpaFormUploaded: "PDPA同意書をアップロードしました ✓",
    documentUploaded: "書類をアップロードしました ✓",
    uploaded: "アップロードしました ✓",
    translationUploaded: "翻訳をアップロードしました ✓",
    uploadTranslation: "翻訳をアップロード",
    relationshipProof: {
      title: "続柄証明書類",
      subtitle: "コア会員との続柄を証明する公式書類をアップロードしてください。",
      marriageCert: "婚姻証明書",
      birthCert: "出生証明書",
      adoptionCert: "養子縁組証明書",
      civilUnionCert: "シビルユニオン証明書",
      notInEnglish: "この書類は英語ではありません",
      certifiedTranslation: "公認英語翻訳",
    },
    signatureCapture: {
      title: "電子署名（任意）",
      subtitle: "署名を描くかアップロードして、すべての申請書類に適用します。",
      saved: "署名を保存しました",
      willBeApplied: "すべての書類に適用されます",
      confirm: "内容を理解し、電子署名を希望します",
      disclaimer1: "申請者は申請書の全ページにご自身で署名する必要があります。申請者が20歳未満の場合は、法定代理人も署名する必要があります。",
      disclaimer2: "すべての署名はパスポートの署名と完全に一致している必要があります。",
      disclaimer3: "⚠️ 電子署名を許可していますが、場合によっては Thailand Privilege Card から、全ページを印刷し手書きで署名してスキャンしたコピーの提出を求められることがあります。プリンターとスキャナーをお持ちの場合は、印刷して手書きで署名することを強くお勧めします。",
      options: {
        upload: {
          title: "署名をアップロード",
          desc: "署名の画像をアップロード",
          instruction: "画像ファイルをここにクリックまたはドラッグ",
          enhancing: "補正中…",
          clickToUpload: "クリックしてアップロード",
        },
        passport: {
          title: "パスポートの署名を使用",
          desc: "アップロードしたパスポートスキャンから署名を抽出します",
          passportRef: "パスポートスキャン",
          notFound: "パスポートスキャンが見つかりません — 先にパスポートをアップロードしてください",
          instruction: "クリックしてパスポートから署名を抽出",
          uploadBtn: "パスポートから抽出",
        },
        draw: {
          title: "署名を描く",
          desc: "マウスまたは指で署名を描いてください",
        },
      },
    },
  },

  review: {
    title: "確認・提出",
    subtitle: "提出前に申請内容をご確認ください。",
    applicationSummary: "申請概要",
    membershipPackage: "会員プログラム",
    fullName: "氏名",
    nationality: "国籍",
    dateOfBirth: "生年月日",
    passportNo: "パスポート番号",
    passportExpiry: "パスポート有効期限",
    occupation: "職業",
    country: "国",
    city: "市区町村",
    phone: "電話番号",
    email: "メール",
    remaining: "残り",
    requiredDocuments: "必要書類",
    passportPhoto: "パスポート / 身分証明書写真",
    profilePhoto: "プロフィール写真",
    applicationFormSigned: "申請フォーム（署名済み）",
    pdpaFormSigned: "PDPA同意書（署名済み）",
    missingDocsWarning: "提出前にステップ6で全ての必要書類を完成させてください。",
    // Validation issues
    validation: {
      fullNameMissing: "氏名が未入力です",
      passportNoMissing: "パスポート番号が未入力です",
      passportExpiryMissing: "パスポートの有効期限が未入力です",
      passportValidityWarning: "パスポートの有効期間は申請日から1年以上である必要があります",
      nationalityMissing: "国籍が未入力です",
      otherNationalityMissing: "他の国籍に関する質問が未回答です",
      phoneMissing: "電話番号が未入力です",
      countryMissing: "居住国が未入力です",
      cityMissing: "市区町村が未入力です",
      missingInfoTitle: "情報が不足しています — 提出前にご記入ください",
      goTo: "移動：",
      completeBeforeSubmitting: "提出前に上記の不足している情報をご記入ください",
      accountFlaggedTitle: "アカウントにフラグが付けられました",
      uploadFlagged: "アップロードされたファイルの一つが書類の規定を満たしていないため、アカウントは確認待ちとしてフラグが付けられました。誤りの場合はメッセージをお送りください。担当チームが確認します。",
      contactUs: "メッセージを送る",
      passportNotGenuine: "アップロードされたファイルは読み取り可能なパスポートの身分事項ページ（顔写真と下部の2行のコードがあるページ）ではありません。実際のパスポートの鮮明なコピーをアップロードしてください。",
      passportDataMismatch: "一部の情報がスキャンしたパスポートと一致しません：{{fields}}。パスポートと完全に一致するよう修正してください。",
      mismatchConfirm: "入力内容は正しいです。チームにパスポートを確認してもらいます",
      fieldPassportNo: "パスポート番号",
      fieldDob: "生年月日",
      fieldExpiry: "パスポートの有効期限",
    },
    survey: {
      title: "アンケート",
      howDidYouLearn: "タイランドエリートをどのようにお知りになりましたか？",
      mainReason: "申請の主な理由は？",
      expectation: "会員資格に何を期待していますか？",
    },
    agreement: "私は提供した全ての情報が正確、完全、かつ真実であることを確認します。Dreamondおよびタイランドプリビレッジカード株式会社が会員申請の目的で私の個人データおよび書類（AI支援パスポートOCRおよび署名確認を含む）を処理することに同意します。申請が正式に承認されるまで支払いは不要であり、いかなる支払いもタイランドプリビレッジカード株式会社の公式請求書に基づいて同社に直接行われる必要があることを理解しています。以下を読み、同意します：",
    termsAndConditions: "利用規約",
    and: "および",
    privacyPolicy: "プライバシーポリシー",
    noPaymentNote: "正式承認まで支払い不要",
    missingDocumentsError: "書類不足",
    missingDocumentsErrorDesc: "提出前に全ての必要書類をアップロードしてください。",
    submittedTitle: "申請が提出されました！",
    submittedDesc: "申請内容を確認し、追ってご連絡いたします。",
    submissionFailed: "提出に失敗しました",
  },

  screens: {
    common: {
      contactSupport: "ご不明な点は当チームまでご連絡ください：",
    },
    approved: {
      title: "おめでとうございます！申請が承認されました",
      message: "承認レターと請求書につきましては、メールをご確認ください。会員資格を有効化するには、30日以内にお支払いを完了する必要があります。",
      uploadTitle: "支払い証明をアップロード",
      uploadHint: "銀行振込の控え、スクリーンショットまたはPDF（最大10MB）",
      uploadButton: "支払い証明をアップロード",
      uploadSuccess: "支払い証明をアップロードしました",
      uploadSuccessDesc: "経理部門が通常約3営業日以内にお支払いを確認いたします。",
      uploadedConfirmation: "支払い証明をアップロードしました — 確認中",
      cardPaymentTitle: "クレジットカードで支払う",
      cardPaymentHint: "経理チームに安全なお支払いリンクをご依頼ください",
      requestLink: "クレジットカード支払いリンクを依頼",
      payByCard: "クレジットカードで支払う",
      linkRequested: "依頼を送信しました",
      linkRequestedDesc: "経理チームよりまもなくお支払いリンクをお送りします。",
      note: "すでに支払い証明をアップロードされている場合は、これ以上の操作は不要です。",
      proofRejectedTitle: "支払い証明を確認できませんでした",
      proofRejectedHelp: "下のボタンから新しい支払い証明をアップロードしてください。ご不明な点は、メールにご返信いただくかお問い合わせください。",
    },
    paymentPending: {
      title: "支払い確認中",
      message: "支払い証明を受け取り、確認のため経理部門へ送付しました。確認には通常約3営業日、その後会員資格の有効化とウェルカムレターの発行に約4営業日かかります。",
      verifying: "支払いを確認中…",
      uploaded: "アップロード済み",
      expected: "確認予定",
      uploadDate: "アップロード日",
      expectedDate: "確認予定日",
      activationDate: "有効化の目安",
      note: "目安の期間です（合計約7営業日）。入金が反映されるタイミングや経理部門の混雑状況により前後する場合があります。",
      verifiedTitle: "お支払いが確認されました",
      verifiedMessage: "お支払いが確認されました。現在、会員資格を発行中です。ウェルカムレターは通常約4営業日以内に届きます。",
      addTitle: "支払い関連書類を追加",
      addHint: "経理部門から追加書類を求められた場合や、銀行取引明細書・デビットアドバイス・SWIFT MT103 をお持ちの場合は、こちらから追加してください。すべての書類はまとめて確認されます。",
      addButton: "書類を追加",
      added: "書類を追加しました",
      documentsTitle: "送付済みの書類",
    },
    paymentDone: {
      title: "支払いが確認されました",
      message: "お支払いが経理部門により確認されました。まもなくウェルカムレターと会員カード情報をメールでお送りします。",
      verified: "支払いを確認しました ✓",
      nextStepsTitle: "次のステップは？",
      step1: "ウェルカムレターをメールでお受け取りいただきます",
      step2: "会員カードを準備いたします",
      step3: "ビザ貼付のご予約についてご連絡いたします",
      package: "ご加入の会員資格",
    },
    prePayment: {
      title: "お支払い前の重要なご案内",
      intro: "以下のいずれかに該当する場合は、お支払いをお控えください。",
      conditions: [
        {
          title: "入国スタンプの有効性",
          detail: "パスポートの入国スタンプに記載された滞在許可が有効である必要があります。現在の滞在中にオーバーステイの記録がある申請者は、いかなる場合もタイランド・プリビレッジ（Thailand Privilege）ビザを取得できません。",
        },
        {
          title: "非移民 O（ボランティア）ビザ",
          detail: "現在、または過去のいずれかの時点で非移民 O 類（ボランティア）ビザを保持していた申請者は、いかなる場合もタイランド・プリビレッジビザを取得できません。",
        },
        {
          title: "非移民 MT または ED ビザ",
          detail: "病院発行の患者報告書または診断書を伴わない非移民 MT（医療）ビザ、あるいは基礎教育委員会事務局（OBEC）発行の公式文書および関係書類を伴わない非移民 ED（就学）ビザを現在保持している申請者は、いかなる場合もタイランド・プリビレッジビザを取得できません。",
        },
      ],
      warning: "上記のいずれかに該当する場合、Thailand Privilege Card Co., Ltd. は会員費を返金せずに留保する権利を留保します。",
      rulesTitle: "お支払い条件",
      rules: [
        { text: "会員費は、マネーロンダリング防止法 B.E. 2542 (1999) および同改正法に従い、一回の取引で送金してください。モバイルバンキングによる送金の場合も、一回の操作で全額をお支払いいただく必要があります。" },
        { text: "Thailand Privilege Card Co., Ltd. が受領する金額は、会員費の全額である必要があります。銀行手数料、中継銀行手数料、代理店手数料、その他国内外の送金手数料はすべて別途ご負担ください。" },
        { text: "承認書および請求書の有効期間は発行日から 30 日間です。期限を過ぎた申請は、改めて身元調査の対象となります。" },
        { text: "請求書に記載された期日を過ぎたお支払いは受け付けられず、各種プロモーションの対象外となります。" },
        { text: "アメリカン・エキスプレスカードはご利用いただけません。" },
      ],
      doubt: "これらの条件に該当するかご不明な場合は、お支払い前にご連絡ください。事前に書類を確認いたします。",
    },

    visaAffix: {
      title: "ビザ貼付の申請",
      intro: "当社チームへ申請をお送りください。お客様のファイルにある書類を添付のうえ、メンバー・コンタクト・センターへ転送し、予約の進捗を確認いたします。",
      locationLabel: "ビザ貼付をご希望の場所",
      locations: {
        chaengWattana: "チェーンワッタナ入国管理局（バンコク）",
        suvarnabhumi: "スワンナプーム空港（到着時）",
        phuket: "プーケット国際空港（到着時）",
        chiangMai: "チェンマイ国際空港（到着時）",
        overseas: "タイ国外（タイ大使館・総領事館経由の e-Visa）",
      },
      noticeThailand: "予約は 5〜7 営業日前までに必要で、Elite Personal Liaison の対応可否によります。",
      noticeOverseas: "e-Visa はタイ政府の公式ポータルを通じて発給されます。申請から 15〜30 営業日を見込んでください。",
      dateLabel: "ご希望日",
      flightLabel: "到着便",
      flightPlaceholder: "例：TG911、10月14日",
      documentsLabel: "ファイル内の書類",
      documentsHint: "添付する書類をお選びください。初期設定ではすべて含まれます。",
      documentTypes: {
        passport_photo: "パスポート",
        application_form: "申請書",
        consent_form: "同意書",
        payment_proof: "支払い証明",
      },
      submit: "申請メールを作成",
      mccTitle: "メンバー・コンタクト・センター",
      mccHint: "ご自身で予約される場合は、会員番号をお伝えのうえ MCC へ直接ご連絡ください。",
      email: {
        subject: "ビザ貼付の申請",
        intro: "Privilege Entry ビザ貼付の予約を申請いたします。",
        member: "会員",
        card: "会員番号",
        package: "会員種別",
        location: "ご希望の場所",
        preferredDate: "ご希望日",
        flight: "到着便",
        documentsHeld: "ファイルより添付をお願いします",
        noneSelected: "書類が選択されていません",
        notSpecified: "指定なし",
        closing: "よろしくお願いいたします。",
      },
    },

    active: {
      title: "Thailand Elite へようこそ！",
      subtitle: "おめでとうございます — あなたは正式な Thailand Elite 会員になりました。",
      cardNo: "会員番号",
      package: "プログラム",
      validFrom: "有効開始日",
      validUntil: "有効期限",
      requestVisaAffix: "ビザ貼付を依頼",
      memberArea: "会員ダッシュボード",
    },
    rejected: {
      title: "申請は承認されませんでした",
      titleCancelled: "申請がキャンセルされました",
      message: "残念ながら、今回お客様の申請を承認することができませんでした。この決定についてご不明な点がございましたら、サポートチームまでお問い合わせください。",
      messageCancelled: "この申請はキャンセルされました。再度申請をご希望の場合は、新しい申請を開始できます。",
      messageInactive: "この申請は長期間操作がなかったため終了しました。入力内容はすべて保存されています。中断したところから再開できます。",
      resume: "申請を再開する",
      resumedToast: "おかえりなさい！申請が再び開かれました。",
      resumeFailed: "この申請を再開できませんでした。メッセージでお問い合わせください。",
      info: "再度申請をご希望の場合は、新しい申請を開始できます。",
      startNew: "新しい申請を開始",
    },
  },

  auth: {
    login: {
      title: "会員ポータル",
      subtitle: "アカウントにサインイン",
      email: "Eメール",
      continueWithEmail: "Eメールで続行",
      sendingLink: "リンクを送信中…",
      noPasswordNote: "安全なサインインリンクをお送りします — パスワードは不要です。",
      noAccount: "アカウントをお持ちではありませんか？",
      createOne: "作成する",
      checkEmailTitle: "Eメールを確認してください",
      checkEmailDesc: "<strong>{{email}}</strong>にサインインリンクを送信しました。リンクをクリックしてアカウントにアクセスしてください。",
      didntReceive: "届きませんでしたか？",
      tryAgain: "もう一度試す",
      accountDisabledTitle: "アカウント無効",
      accountDisabledMsg: "あなたのアカウントは無効になっています。",
      accountDisabledReason: "理由:",
      accountDisabledContact: "これが間違いであると思われる場合は、までご連絡ください。",
    },
    register: {
      title: "アカウントを作成",
      subtitle: "タイランドエリートの旅を始めましょう",
      firstName: "名",
      lastName: "姓",
      email: "Eメール",
      phoneNumber: "電話番号",
      searchCountry: "国を検索…",
      continueWithEmail: "Eメールで続行",
      sendingLink: "マジックリンクを送信中…",
      noPasswordNote: "Eメールを確認してサインインするための安全なリンクをお送りします — パスワードは不要です。",
      alreadyHaveAccount: "すでにアカウントをお持ちですか？",
      signIn: "サインイン",
      checkEmailTitle: "Eメールを確認してください",
      checkEmailDesc: "<strong>{{email}}</strong>にマジックリンクを送信しました。Eメールのリンクをクリックしてサインインし、登録を完了してください。",
      didntReceive: "届きませんでしたか？",
      tryAgain: "もう一度試す",
    },
  },
};
